import { GeneralInsurance } from '@/app/general-insurance/entities/general-insurance.entity'

export interface GeneralInsuranceState {
    generalInsurances: GeneralInsurance[]
}

export const state: GeneralInsuranceState = {
    generalInsurances: []
}
